import styled from "styled-components"

import { Typography } from "components/common/index"

const PageTitle = styled(Typography).attrs((props) => ({
  as: "h1",
  pb: props.pb,
}))`
  ${({ theme }) => `
    display: block;
    color: ${theme.colors.black};
    font-size: ${theme.fontSizes[20]};
    font-weight: bold;
    letter-spacing: 1.5px;
    margin: 0;
    padding-top: ${theme.space[4]};
  `}
  ${({ theme }) => theme.mediaQueries.tablet`
    font-size: ${theme.fontSizes[26]};
  `};
`

export default PageTitle
